import { useState, useEffect } from 'react';
import { hot } from 'react-hot-loader';
import { Link } from 'react-router-dom';
import { utils, ethers } from 'ethers';

import { useSelector } from 'react-redux';
import { useEagerConnect, useActiveWeb3React } from '../hooks/index';
//import useAuth from '../hooks/useAuth';
import LinkExternal from '../components/Link/LinkExternal';
import getNftContract from '../hooks/getNftContract';
import getNftAddress from '../hooks/getNftAddress';
import getRnctContract from '../hooks/getRnctContract';
import getRnctAddress from '../hooks/getRnctAddress';
import getNftBurnContract from '../hooks/getNftBurnContract';
import getNftBurnAddress from '../hooks/getNftBurnAddress';
import Card from '../components/Card';
import * as S from '../store/selectors';
import { ipfsPrfix } from '../configs';
import { TextArea } from '@adobe/react-spectrum';
import ConnectWalletButton from '../components/ConnectWalletButton';


import { toast } from 'react-toastify';
//import copy from 'copy-to-clipboard';

import './ScreenTerms.scss';



function ScreenWallet2(props) {
  //const traitsCount = useSelector(S.nft.getTraitsCount);
  //const traits = useSelector(S.nft.getTraits);
  const tokens = useSelector(S.nft.getTokens);
  const blockNumber = useSelector(S.provider.getBlockNumber);


  const triedEager = useEagerConnect();
  const context = useActiveWeb3React();
  const { library, chainId, account, active } = context;


  const [ids, setIds] = useState([]);
  const [balanceRnct, setBalanceRnct] = useState('0');
  const [unclaimedRnct, setUnclaimedRnct] = useState('0');

  useEffect(async () => {
    const contract = getNftContract(chainId, library);
    //const contract3 = getRnctContract(chainId, library);
    if (contract) {
      let balance = await contract.balanceOf(account);
      balance = balance.toNumber();
      //setBalance(balance);
      if (balance > 0) {
        let tokenIds = [];
        if (balance < 104) {
          tokenIds = await contract.tokensOfOwner(account);
        } else {
          let i = 0;
          while (i < balance) {
            tokenIds.push(
              await contract.tokenOfOwnerByIndex(account, i)
            );
            i++;
            setIds(tokenIds);
          }
        }
        setIds(tokenIds);
      }
      /*const tokenIds = [];
      for (let i in ids) {
        tokenIds.push(ids[i].toNumber());
      }
      let rnct = await contract3.accumulatedBatch(ids);
      let rnctTotal = parseFloat(utils.formatEther(rnct));
      setUnclaimedRnct(rnctTotal);
 
      let balance = await contract3.balanceOf(account);
      balance = parseFloat(utils.formatEther(balance));
      setBalanceRnct(balance);*/
    }
  }, [account]);

  const etherscan = `https://${chainId === 4 ? 'rinkeby.' : ''}etherscan.io`;

  const handleClaimRnct = async () => {
    if (account && parseFloat(unclaimedRnct) > 0) {
      try {
        const contract = getNftContract(chainId, library);
        if (contract) {
          const ids = await contract.tokensOfOwner(account);
          setIds(ids);
          if (ids.length === 0) return;

          const contract2 = getRnctContract(chainId, library, true);
          const tx = await contract2.claim(ids);
          toast.info(<LinkExternal href={etherscan + '/tx/' + tx.hash}>Pending. tx: {tx.hash.substring(0, 6)}...</LinkExternal>);
          await tx.wait(1);
          toast.success(<LinkExternal href={etherscan + '/tx/' + tx.hash}>Done. tx: {tx.hash.substring(0, 6)}...</LinkExternal>);

          setUnclaimedRnct('0');
        }
      } catch (error) {
        if (typeof error === 'string' && error.includes('insufficient funds')) {
          toast.error('Insufficient funds');
        } else if (typeof error === 'object' && error.message.includes('insufficient funds')) {
          toast.error('Insufficient funds');
        } else {
          //console.error(error);
          toast.error('Error');
        }
      }
    }
  }

  const addRnctToMetaMask = async () => {
    const tokenAdded = await window.ethereum.request({
      method: 'wallet_watchAsset',
      params: {
        type: 'ERC20',
        options: {
          address: getRnctAddress(chainId),
          symbol: 'RNCT',
          decimals: 18,
          image: 'https://roborovski.org/logo.jpg',
        },
      },
    });
  }


  let [text, setText] = useState('');
  useEffect(() => {
    setText(ids.join(','));
  }, [ids]);

  const handleChange = (newText) => {
    setText(newText);
  }
  const handleSelectAll = () => {
    setText(ids.join(','));
  }
  const handleBurn = async () => {
    const temp = text.split(',');
    const list = [];
    for (let i in temp) {
      temp[i] = parseInt(temp[i].trim());
      for (let j in ids) {
        if (ids[j].toNumber() === temp[i]) {
          list.push(temp[i]);
        }
      }
    }
    setText(list.join(','));
    if (list.length === 0) return;

    const contractNft = getNftContract(chainId, library, true);
    const nftBurnAddress = getNftBurnAddress(chainId);
    let isApproved = false;
    try {
      isApproved = await contractNft.isApprovedForAll(account, nftBurnAddress);
      if (!isApproved) {
        let gasLimit;
        gasLimit = await contractNft.estimateGas.setApprovalForAll(nftBurnAddress, true);
        gasLimit = gasLimit.mul(135).div(100);
        toast.info('Make an approval for burning!');
        let tx = await contractNft.setApprovalForAll(nftBurnAddress, true, { gasLimit });
        toast.info('Waiting for confirmation.');
        await tx.wait(1);
        isApproved = await contractNft.isApprovedForAll(account, nftBurnAddress);
      }
    } catch (error) {
      if (typeof error === 'string') {
        toast.error('Error: ' + error);
      } else if (typeof error === 'object' && error.error) {
        toast.error('Error: ' + error.error.message);
      } else {
        toast.error('Error');
      }
      return;
    }
    let balanceRaw = await library.getBalance(nftBurnAddress);
    const balanceInEth = parseFloat(ethers.utils.formatEther(balanceRaw));

    if (list.length * 0.05 > (balanceInEth - 1)) {
      toast.error('Insufficient funds on the contract');
      return;
    }

    const contractBurn = getNftBurnContract(chainId, library, true);
    if (contractBurn && contractNft && isApproved && list.length > 0) {
      try {
        let gasLimit;
        gasLimit = await contractBurn.estimateGas.burn(list);
        gasLimit = gasLimit.mul(135).div(100);
        toast.info('Sign the transaction to burn.');
        const tx = await contractBurn.burn(list, { gasLimit });
        toast.info(<LinkExternal href={etherscan + '/tx/' + tx.hash}>Pending. tx: {tx.hash.substring(0, 6)}...</LinkExternal>);
        await tx.wait(1);
        toast.success(<LinkExternal href={etherscan + '/tx/' + tx.hash}>Done. tx: {tx.hash.substring(0, 6)}...</LinkExternal>);
        window.location.reload(true);
      } catch (error) {
        if (typeof error === 'string') {
          toast.error('Error: ' + error);
        } else if (typeof error === 'object' && error.error) {
          toast.error('Error: ' + error.error.message);
        } else {
          toast.error('Error');
        }
      }
    } else {
      toast.error('Wrong');
    }
  }

  return (
    <section className="section-terms">
      <div className="container" data-aos="fade-in" data-delay="200">
        <div className="pre-title">
          <Link className="pre-title-back" to="/">&larr; Go to homepage</Link>
        </div>

        {!active && <div className="row">
          <div className="col-12 col-lg-10 offset-lg-1 col-xl-8 offset-xl-2">
            <div className="modal-header">Your Wallet</div>
            <div className='address' style={{ color: '#fbbd74', }}> </div>

            <div style={{ marginTop: '10px' }}>
              <div className="modal-header">
                <ConnectWalletButton />
              </div>
            </div>

            <br />

            <br />
            <div className="container">
              <div className="row">
                {ids.map((item, index) => {
                  const token = tokens[item - 1];
                  return (
                    <div className="col-xl-3 col-lg-3 col-12 mb-5" key={index}>
                      <Link to={`/details/${item}`}>
                        <Card
                          //poster={nft1Img} posterhd={`${nft1X2Img} 2x`}
                          poster={`${ipfsPrfix}${token ? token.thumbIpfs : 'QmWG8P7koQoujLc3zn7zZR6HKarinpDtoKx5oaqjtu7fYi'}`}
                          name={`${token ? token.traits.Surname : 'Roborovski'} #${item}`}
                        /*summ="2.28"
                        icon1="1"
                        icon2="4"*/
                        />
                      </Link>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>}


        {active && <div className="row">
          <div className="col-12 col-lg-10 offset-lg-1 col-xl-8 offset-xl-2">
            <div className="modal-header">Your Wallet</div>
            <div className='address' style={{ color: '#fbbd74', }}>
              <LinkExternal href={`https://etherscan.io/address/${account}`}>
                {account}
              </LinkExternal>
            </div>

            <div style={{ marginTop: '10px' }}>
              <div className="modal-header"><LinkExternal href={etherscan + '/token/' + getNftAddress(chainId) + `?a=${account}`}>
                You own <span style={{ color: '#fbbd74', }}>{ids.length}</span> ROBO
              </LinkExternal>
              </div>

              {/*ids.length > 0 && <div style={{ color: '#fff', }}>
                <form onSubmit={handleBurn}>
                  Token IDs to Burn:
                  <TextArea
                    isRequired
                    type='text'
                    inputMode='text'
                    width='100%'
                    value={text}
                    onChange={handleChange}
                    style={{ backgroundColor: 'red!important' }}
                  />
                  <br />
                  <div className="sel__res">
                    <div className="sel__res-col sel__res-col--1">
                      <button
                        style={{ width: '100%', height: '100%', padding: '1.3rem', backgroundColor: '#fbbd74', }}
                        onClick={handleSelectAll}
                      >SELECT ALL</button>
                    </div>
                    <div className="sel__res-col sel__res-col--2">
                      <button
                        type="submit"
                        style={{ width: '100%', height: '100%', padding: '1.3rem', backgroundColor: '#fbbd74', }}
                      //onClick={handleBurn}
                      >BURN</button>
                    </div>
                  </div>
                </form>
              </div>*/}
            </div>

            <br />

            <br />
            <div className="container">
              <div className="row">
                {ids.map((item, index) => {
                  const token = tokens[item - 1];
                  return (
                    <div className="col-xl-3 col-lg-3 col-12 mb-5" key={index}>
                      <Link to={`/details/${item}`}>
                        <Card
                          //poster={nft1Img} posterhd={`${nft1X2Img} 2x`}
                          poster={`${ipfsPrfix}${token ? token.thumbIpfs : 'QmWG8P7koQoujLc3zn7zZR6HKarinpDtoKx5oaqjtu7fYi'}`}
                          name={`${(token && token.traits) ? token.traits.Surname : 'Roborovski'} #${item}`}
                        /*summ="2.28"
                        icon1="1"
                        icon2="4"*/
                        />
                      </Link>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>}
      </div>
    </section>
  );
};

export default hot(module)(ScreenWallet2);
